<!-- Templates para títulos de tabs (ng-zorro v20 usa nzTitle como TemplateRef) -->
<ng-template #tabDirectorTitle>
  <intelishs-tab-label label="Pendientes Director" [count]="totalDirector()" />
</ng-template>

<ng-template #tabRHTitle>
  <intelishs-tab-label label="Pendientes RH" [count]="totalRH()" />
</ng-template>

<div class="page-container">
  <intelishs-page-header
    title="Autorizaciones de Vacaciones"
    subtitle="Flujo de doble aprobación: Director → RH"
  />
  <nz-tabs>
    <!-- Tab 1: RH -->
    <nz-tab [nzTitle]="tabRHTitle">
      @if (porResolverRH().length === 0 && !loading()) {
        <intelishs-empty-state
          variant="card"
          icon="check-circle"
          iconColor="#52c41a"
          title="Sin solicitudes pendientes"
          message="No hay solicitudes que requieran la decisión de RH"
        />
      } @else {
        <intelishs-data-table
          [data]="porResolverRH()"
          [columns]="columnsRH"
          [loading]="loading()"
          [pageSize]="10"
          searchPlaceholder="Buscar por nombre, ID, área o comentarios..."
          [extraFilterKeys]="extraFilterKeys"
          [exportColumns]="exportColumns"
          [showRefreshButton]="true"
          (refresh)="cargar()"
        >
          <!-- El badge de saldo negativo va junto al nombre, no dentro de la
               celda de dos líneas: es una alerta, no contexto del dato. -->
          <ng-template intelishsCellTemplate="empleadoNombre" let-row>
            <div class="celda-empleado">
              <intelishs-cell-stack
                [main]="row.empleadoNombre"
                [meta]="row.empleadoIdInterno + (row.area ? ' · ' + row.area : '')"
              />
              @if (empleadoTieneSaldoNegativo(row.empleadoId)) {
                <span
                  class="badge-saldo-negativo"
                  nz-tooltip
                  nzTooltipTitle="Esta solicitud genera saldo negativo de días"
                  >⚠️</span
                >
              }
            </div>
          </ng-template>

          <!-- Periodo: el rango se lee junto y los días hábiles dan el contexto -->
          <ng-template intelishsCellTemplate="fechaInicio" let-row>
            <intelishs-cell-stack
              [main]="
                (row.fechaInicio | date: 'dd/MM/yyyy') + ' → ' + (row.fechaFin | date: 'dd/MM/yyyy')
              "
              [meta]="
                row.diasSolicitados + (row.diasSolicitados === 1 ? ' día hábil' : ' días hábiles')
              "
            />
          </ng-template>

          <!-- Quién aprobó y qué comentó: son el mismo hecho del flujo. Si el
               jefe todavía no aprueba, la segunda línea lo dice en naranja: es
               lo que RH tiene que notar antes de decidir por encima de él. Dos
               líneas y sin punto, como el resto de la columna (el estado con
               punto es para encabezados, no para una celda). -->
          <ng-template intelishsCellTemplate="aprobadoPorDirector" let-row>
            <intelishs-cell-stack
              [class.celda-sin-aprobacion]="row.estatus === 'Pendiente'"
              [main]="row.aprobadoPorDirector || '—'"
              [meta]="row.estatus === 'Pendiente' ? 'Sin aprobación' : row.comentariosDirector || ''"
            />
          </ng-template>

          <ng-template intelishsCellTemplate="acciones" let-row>
            <intelishs-table-actions
              [row]="row"
              [actions]="rhActions"
              (action)="onActionRH({ action: $event, row })"
            />
          </ng-template>
        </intelishs-data-table>
      }
    </nz-tab>

    <!-- Tab 2: Director (solo lectura) -->
    <nz-tab [nzTitle]="tabDirectorTitle">
      @if (pendientesDirector().length === 0 && !loading()) {
        <intelishs-empty-state
          variant="card"
          icon="check-circle"
          iconColor="#52c41a"
          title="Sin solicitudes pendientes"
          message="No hay solicitudes que requieran aprobación del Director"
        />
      } @else {
        <intelishs-data-table
          [data]="pendientesDirector()"
          [columns]="columnsDir"
          [loading]="loading()"
          [pageSize]="10"
          searchPlaceholder="Buscar por nombre, ID, área o director..."
          [extraFilterKeys]="extraFilterKeysDir"
          [showRefreshButton]="true"
          (refresh)="cargar()"
        >
          <ng-template intelishsCellTemplate="empleadoNombre" let-row>
            <intelishs-cell-stack
              [main]="row.empleadoNombre"
              [meta]="row.empleadoIdInterno + (row.area ? ' · ' + row.area : '')"
            />
          </ng-template>

          <ng-template intelishsCellTemplate="fechaInicio" let-row>
            <intelishs-cell-stack
              [main]="
                (row.fechaInicio | date: 'dd/MM/yyyy') + ' → ' + (row.fechaFin | date: 'dd/MM/yyyy')
              "
              [meta]="
                row.diasSolicitados + (row.diasSolicitados === 1 ? ' día hábil' : ' días hábiles')
              "
            />
          </ng-template>

          <ng-template intelishsCellTemplate="acciones" let-row>
            <intelishs-table-actions
              [row]="row"
              [actions]="dirActions"
              (action)="abrirDetalle(row)"
            />
          </ng-template>
        </intelishs-data-table>
      }
    </nz-tab>
  </nz-tabs>
</div>

<!-- Modal detalle de solicitud -->
<app-solicitud-detalle-modal
  [(visible)]="detalleVisible"
  [solicitud]="detalleEmpleado()"
  modo="rh"
/>

<!-- Modal de confirmación -->
<app-solicitud-aprobar-modal
  [(visible)]="modalVisible"
  [solicitud]="solicitudSeleccionada()"
  [accion]="modalAccion()"
  [paso]="modalPaso()"
  (procesado)="onAprobacionProcesada()"
/>
